<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="name" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
          id="name"
          v-model="formModel.name"
          :class="[
                        'form-control',
                        v.name.$error ? 'is-invalid' : '',
                      ]"
          type="text"
          placeholder=""
        />
        <p v-if="v.name.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.name.$errors[0].$message }}
          </small>
        </p>
          <label for="name" class="form-control-label">
            Descripción
          </label>
          <textarea
              rows="10"
              id="name"
              v-model="formModel.description"
              :class="[
                        'form-control',
                        v.description.$error ? 'is-invalid' : '',
                      ]"
              type="text"
              placeholder=""
          />
          <p v-if="v.description.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.description.$errors[0].$message }}
            </small>
          </p>

        <label for="post_photo" class="form-control-label">
          Imagen<span class="required">*</span>
        </label>
        <el-upload
            class="upload-demo"
            drag
            :action="imagesUrl"
            :headers="headers"
            :on-success="imageUploaded"
            :on-remove="handleRemove"
            v-model:file-list="fileList"
            list-type="picture"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            Arrastre aquí <em>click para subir archivos</em>
          </div>
          <template #tip>
            <!-- <div class="el-upload__tip">
               jpg/png files with a size less than 500kb
             </div>-->
          </template>
        </el-upload>
        <p v-if="v.image.$errors.length" class="invalid-feedback mb-0">
          <small>
            {{ v.image.$errors[0].$message }}
          </small>
        </p>

          <label for="post_icon" class="form-control-label">
            Imagen Icono<span class="required">*</span>
          </label>
          <el-upload
              class="upload-demo"
              drag
              :action="iconsUrl"
              :headers="headers"
              :on-success="iconUploaded"
              :on-remove="handleRemove"
              v-model:file-list="iconFileList"
              list-type="picture"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              Arrastre aquí <em>click para subir archivos</em>
            </div>
            <template #tip>
              <!-- <div class="el-upload__tip">
                 jpg/png files with a size less than 500kb
               </div>-->
            </template>
          </el-upload>
          <p v-if="v.iconImage.$errors.length" class="invalid-feedback mb-0">
            <small>
              {{ v.iconImage.$errors[0].$message }}
            </small>
          </p>

    </div>
      <div class="col-md-6">
        <label for="lang" class="form-control-label w-100">
          Idioma<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.lang"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in langs"
              :key="selectItem.id"
              :value="selectItem.value"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="v.lang.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.lang.$errors[0].$message }}
          </small>
        </p>

        <label for="video" class="form-control-label">
          Video<span class="required">*</span>
        </label>
        <input
            type="file"
            id="video"
            @change="handleFileUpload"
            :class="[ 'form-control']"
            placeholder=""
        />
        <div class="img-thumbnail mt-3">
          <video class="w-100 p-2" muted autoplay v-if="previewUrl" :src="previewUrl"></video>
          <p v-if="v.videoUrl.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.videoUrl.$errors[0].$message }}
            </small>
          </p>
        </div>
      </div>

    <div class="mt-3">
      <button
        type="submit"
        class="
                      float-end
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                    "
      >
        {{ buttonText }}
      </button>
      <button
        class="
                      me-2
                      float-end
                      btn btn-primary
                      text-danger
                      bg-white
                      border border-danger
                      rounded-lg
                      hover:bg-blue-900
                    "
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import {languageList} from "@/utils/languages";

const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const fileList = ref([])
const iconFileList = ref([])
const formModel = ref(props.entity|| {});
const imagesUrl = computed(() => process.env.VUE_APP_URL_API+'/trail_type_images');
const iconsUrl = computed(() => process.env.VUE_APP_URL_API+'/icon_images');
const videoFile = ref(null);
const previewUrl = ref(formModel.value.videoUrl);
const langs = languageList()
const headers = computed(() => ({
  'Authorization': `Bearer ${store.state.auth?.user?.idToken || store.state.auth.idToken}`
}))
const rules = computed(() => {
  return {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    videoUrl: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    image: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    iconImage: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    description: {
      // required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    orderNumber: {

    }
  };
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;
const imageId = ref(null);
const iconId = ref(null);
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');
const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    let payload;
    if (videoFile.value) {
      payload = new FormData();
      Object.entries(formModel.value).forEach(([key, value]) => {
        payload.append(key, value ?? '');
      });
      // Agregar el archivo
      payload.append('file', videoFile.value);
    } else {
      payload = {...formModel.value};
    }
    if(props.action === 'create'){
      createEntity(payload);
    }else{
      updateEntity(payload);
    }

  }
};
const clearForm = ()=>{
  formModel.value.name = null
  formModel.value.image = null
  formModel.value.iconImage = null
}
onMounted(() => {
  if(props.entity.image){
    imageId.value =  props.entity.image.id
    fileList.value.push({
      name: props.entity.image.filePath,
      url: props.entity.image.imageUrl
    })
    formModel.value.image = props.entity.image.id
  }
  if(props.entity.iconImage){
    iconId.value =  props.entity.iconImage.id
    iconFileList.value.push({
      name: props.entity.iconImage.filePath,
      url: props.entity.iconImage.imageUrl
    })
    formModel.value.iconImage = props.entity.iconImage.id
  }

});

const handleCancel = () => {
  router.push({ name: "TrailTypes", params: {} });
};
const handleRemove = (field='image') => {
  if(field === 'image'){
    imageId.value = null
    formModel.value.image = null
  }
  if(field === 'iconImage'){
    iconId.value = null
    formModel.value.iconImage = null
  }

}

const updateEntity = async (data) => {
  try {
    await store.dispatch("trailType/edit", data).then(async (res) => {
      if (res.status && (res.status === 200 || res.status === 201)) {
        await Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Tipología editada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        clearForm()
        await router.push({name: "TrailTypes", params: {}});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ha habido un error.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    });

  } catch (error) {
    await Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Se ha producido un error.',
      showConfirmButton: false,
      timer: 3000
    })
    console.log(error);
  }
};

const createEntity = async (data) => {
  try {
    await store.dispatch("trailType/add", data).then(async (res) => {
      if (res.status && (res.status === 200 || res.status === 201)) {
        await Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Tipología creada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        await router.push({name: "TrailTypes", params: {}});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ha habido un error.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    });

  } catch (error) {
    await Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Se ha producido un error.',
      showConfirmButton: false,
      timer: 3000
    })
    console.log(error);
  }
};
const imageUploaded = (response) => {
    if(response.id){
         imageId.value = response.id;
         formModel.value.image = imageId.value
    }
}
const iconUploaded = (response) => {
  if(response.id){
    iconId.value = response.id;
    formModel.value.iconImage = iconId.value
  }
}
const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    videoFile.value = file;
    previewUrl.value = URL.createObjectURL(file);
    formModel.value.videoUrl = URL.createObjectURL(file);
  }
};
</script>
